
import { Box, Typography } from "@mui/material";

const partyConfig = {
  lab_pred_n: { label: "Labour",   color: "#E82C2C" },
  nat_pred_n: { label: "National", color: "#0056A8" },
  nzf_pred_n: { label: "NZF",      color: "#000000" },
  green_pred_n:{ label: "Green",   color: "#009639" },
  act_pred_n: { label: "ACT",      color: "#FFD700" },
  top_pred_n: { label: "TOP",      color: "#008080" },
  tpm_pred_n: { label: "TPM",      color: "#CC0033" },
  //oth_pred_n:  { label: "Other",   color: "#999999" },
};

export default function ConstituencyGrid({ metricRowsNational = [], latest_wave }) {
  if (!metricRowsNational | !latest_wave) return null;
  
  const rows_filt = metricRowsNational?.find(g => Number(g.wave) === Number(latest_wave)) || {};


  const parties = Object.keys(partyConfig);

  const party_shares =  parties.map((k) =>{
    const v = Number(rows_filt[k])/100
    return{partyKey: k,partyShare:v} })
  const totalShare = party_shares.reduce((sum, p) => Number(sum) + Number(p.partyShare), 0);

  const seats_per_party = parties.map((k) =>{
    const v = Number(rows_filt[k])/100
    const seats = ((v/totalShare)*120).toFixed(0)
    return{partyKey: k,partySeats:seats}
  })



  return (
    <Box sx={{ px: 2, display: "flex", flexDirection: "column", gap: 0.75  }}>
      {seats_per_party.map((group) => (
        <Box
          key={group.partyKey}
          sx={{
            display: "grid",
            gridTemplateColumns: "100px 1fr 30px", // label | squares | count
            alignItems: "center",
            columnGap: 1,
          }}
        >
          {/* Label */}
          <Typography sx={{ fontSize: 12 }}>{partyConfig[group.partyKey].label}</Typography>

          {/* Squares (with tooltip here!) */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {Array.from({ length: Number(group.partySeats) }).map((_, i) => (
        <Box
          key={i}
          sx={{
            width: 12.5,
            height: 12.5,
            bgcolor: partyConfig[group.partyKey]?.color || "grey",
            borderRadius: "2px",
          }}
        />
      ))}
          </Box>

          {/* Count */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography sx={{ fontSize: 12, fontWeight: 500 }}>
              {group.partySeats}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
